import React from 'react'
import { Navigate, Routes, Route } from 'react-router-dom'
import PrivateRoute from './privateRoute'
import { useAuth } from '../hooks/AuthContext'
import { ROLE } from './roles'
import { useLocation } from 'react-router-dom'

import ChangePassword from '../pages/ChangePassword'
import ForgotPassword from '../pages/ForgotPassword'
import Login from '../pages/Login'

import EntregasCustomer from '../pages/Customer/Entregas'

import AdminEditar from '../pages/Admin/Admins/AdminEditar'
import AdminEditarUsuario from '../pages/Admin/Editar'
import AdminEmpresaEditar from '../pages/Admin/Empresas/EmpresasEditar'
import AdminNovo from '../pages/Admin/Admins/AdminNovo'
import Admins from '../pages/Admin/Admins'
import EmpresaNova from '../pages/Admin/Empresas/EmpresasNova'
import Empresas from '../pages/Admin/Empresas'
import InicioAdmin from '../pages/Admin/Inicio'

import InicioAttendant from '../pages/Attendant/Inicio'
import AtendenteEditarUsuario from '../pages/Attendant/Editar'
import AtendenteEntregas from '../pages/Attendant/Entregas'
import EntregasAtendente from '../pages/Attendant/Veiculos/Entregas'
import AtendenteEntregaInfo from '../pages/Attendant/Entregas/EntregaInfo'

import Atendentes from '../pages/Company/Atendentes'
import AtendentesEditar from '../pages/Company/Atendentes/AtendentesEditar'
import AtendentesNovo from '../pages/Company/Atendentes/AtendentesNovo'
import EmpresaEditar from '../pages/Company/Editar'
import Entregas from '../pages/Company/Veiculos/Entregas/Entregas'
import GestoresEntregas from '../pages/Company/GestoresEntregas'
import GestoresEntregasEditar from '../pages/Company/GestoresEntregas/GestoresEntregasEditar'
import GestoresEntregasNovo from '../pages/Company/GestoresEntregas/GestoresEntregasNovo'
import Inicio from '../pages/Company/Inicio'
import Motoristas from '../pages/Company/Motoristas'
import MotoristasAvaliacoes from '../pages/Company/Motoristas/MotoristasAvaliacoes'
import MotoristasEditar from '../pages/Company/Motoristas/MotoristasEditar'
import MotoristasInfo from '../pages/Company/Motoristas/MotoristasInfo'
import MotoristasNovo from '../pages/Company/Motoristas/MotoristasNovo'
import Veiculos from '../pages/Company/Veiculos'
import VeiculosEditar from '../pages/Company/Veiculos/VeiculosEditar'
import VeiculosInfo from '../pages/Company/Veiculos/VeiculosInfo'
import VeiculosNovo from '../pages/Company/Veiculos/VeiculosNovo'

import InicioDeliveryManager from '../pages/DeliveryManager/Inicio'
import Pedidos from '../pages/DeliveryManager/Pedidos'
import EntregasManager from '../pages/DeliveryManager/Entregas'
import MultasNova from '../pages/DeliveryManager/Veiculos/Multas/MultasNova'
import MultasEditar from '../pages/DeliveryManager/Veiculos/Multas/MultasEditar'
import Multas from '../pages/DeliveryManager/Veiculos/Multas'
import Abastecimentos from '../pages/DeliveryManager/Veiculos/Abastecimentos'
import Manutencoes from '../pages/DeliveryManager/Veiculos/Manutencoes'
import AbastecimentosNovo from '../pages/DeliveryManager/Veiculos/Abastecimentos/AbastecimentosNovo'
import ManutencoesNova from '../pages/DeliveryManager/Veiculos/Manutencoes/ManutencoesNova'
import AbastecimentosEditar from '../pages/DeliveryManager/Veiculos/Abastecimentos/AbastecimentosEditar'
import ManutencoesEditar from '../pages/DeliveryManager/Veiculos/Manutencoes/ManutencoesEditar'
import EntregasGestor from '../pages/DeliveryManager/Veiculos/Entregas/Entregas'
import GestorEntregasEditarUsuario from '../pages/DeliveryManager/Editar'
import EntregaInfo from '../pages/DeliveryManager/Entregas/EntregaInfo'
import EntregasProblemas from '../pages/DeliveryManager/Entregas/EntregasProblemas'
import EntregasProblemasNovo from '../pages/DeliveryManager/Entregas/EntregasProblemas/EntregaProblemasNovo'
import EntregasProblemasEditar from '../pages/DeliveryManager/Entregas/EntregasProblemas/EntregaProblemasEditar'
import Cargas from '../pages/DeliveryManager/Veiculos/Cargas'
import EntregasEstatisticas from '../pages/Company/EntregasEstatisticas'

const adminRoutes = [
  { path: '/admin/inicio', element: <InicioAdmin /> },
  { path: '/admin/editar', element: <AdminEditarUsuario /> },
  { path: '/admin/admins/novo', element: <AdminNovo /> },
  { path: '/admin/admins', element: <Admins /> },
  { path: '/admin/admins/editar/:id', element: <AdminEditar /> },
  { path: '/admin/empresas', element: <Empresas /> },
  { path: '/admin/empresas/nova', element: <EmpresaNova /> },
  { path: '/admin/empresas/editar/:id', element: <AdminEmpresaEditar /> },
]

const companyRoutes = [
  { path: '/empresa/inicio', element: <Inicio /> },
  { path: '/empresa/motoristas/listar', element: <Motoristas /> },
  { path: '/empresa/motoristas/novo', element: <MotoristasNovo /> },
  { path: '/empresa/motoristas/editar/:id', element: <MotoristasEditar /> },
  { path: '/empresa/veiculos', element: <Veiculos /> },
  { path: '/empresa/veiculos/novo', element: <VeiculosNovo /> },
  { path: '/empresa/veiculos/editar/:id', element: <VeiculosEditar /> },
  { path: '/empresa/veiculos/info/:id/entregas-do-dia', element: <Entregas /> },
  { path: '/empresa/gestores-entregas', element: <GestoresEntregas /> },
  { path: '/empresa/gestores-entregas/novo', element: <GestoresEntregasNovo /> },
  { path: '/empresa/gestores-entregas/editar/:id', element: <GestoresEntregasEditar /> },
  { path: '/empresa/atendentes', element: <Atendentes /> },
  { path: '/empresa/atendentes/novo', element: <AtendentesNovo /> },
  { path: '/empresa/atendentes/editar/:id', element: <AtendentesEditar /> },
  { path: '/empresa/veiculos/info/:id', element: <VeiculosInfo /> },
  { path: '/empresa/motoristas/info/:id', element: <MotoristasInfo /> },
  { path: '/empresa/editar', element: <EmpresaEditar /> },
  { path: '/empresa/motoristas/avaliacoes', element: <MotoristasAvaliacoes /> },
  { path: '/empresa/estatisticas', element: <EntregasEstatisticas /> },
]

const managerRoutes = [
  { path: '/gestor-entregas/inicio', element: <InicioDeliveryManager /> },
  { path: '/gestor-entregas/editar', element: <GestorEntregasEditarUsuario /> },
  { path: '/gestor-entregas/entregas/todas', element: <EntregasManager /> },
  { path: '/gestor-entregas/entregas/problemas', element: <EntregasProblemas /> },
  { path: '/gestor-entregas/entregas/problemas/novo', element: <EntregasProblemasNovo /> },
  { path: '/gestor-entregas/entregas/problemas/:id/editar', element: <EntregasProblemasEditar /> },
  { path: '/gestor-entregas/pedidos', element: <Pedidos /> },
  { path: '/gestor-entregas/veiculos/multas/nova', element: <MultasNova /> },
  { path: '/gestor-entregas/veiculos/multas', element: <Multas /> },
  { path: '/gestor-entregas/veiculos/manutencoes', element: <Manutencoes /> },
  { path: '/gestor-entregas/veiculos/abastecimentos', element: <Abastecimentos /> },
  { path: '/gestor-entregas/veiculos/cargas', element: <Cargas /> },
  { path: '/gestor-entregas/veiculos/multas/editar/:id', element: <MultasEditar /> },
  { path: '/gestor-entregas/veiculos/info/:id/entregas-do-dia', element: <EntregasGestor /> },
  { path: '/gestor-entregas/veiculos/abastecimentos/novo', element: <AbastecimentosNovo /> },
  {
    path: '/gestor-entregas/veiculos/abastecimentos/editar/:id',
    element: <AbastecimentosEditar />,
  },
  { path: '/gestor-entregas/veiculos/manutencoes/nova', element: <ManutencoesNova /> },
  { path: '/gestor-entregas/veiculos/manutencoes/editar/:id', element: <ManutencoesEditar /> },
  { path: '/gestor-entregas/entregas/:id', element: <EntregaInfo /> },
]

const attendantRoutes = [
  { path: '/atendente/inicio', element: <InicioAttendant /> },
  { path: '/atendente/editar', element: <AtendenteEditarUsuario /> },
  { path: '/atendente/entregas', element: <AtendenteEntregas /> },
  { path: '/atendente/veiculos/info/:id/entregas-do-dia', element: <EntregasAtendente /> },
  { path: '/atendente/entregas/:id', element: <AtendenteEntregaInfo /> },
]

const RoutesFunction: React.FC = () => {
  const renderRoutes = (routes: { path: string; element: JSX.Element }[], role: any) =>
    routes.map((route) => (
      <Route
        key={route.path}
        path={route.path}
        element={<PrivateRoute roles={role}>{route.element}</PrivateRoute>}
      />
    ))
  return (
    <Routes>
      <Route path="*" element={<Navigate to="/login" replace />} />
      <Route path="/cliente/entregas/:id/:invoice" element={<EntregasCustomer />} />
      <Route
        path="/login"
        element={
          <RedirectLogin>
            <Login />
          </RedirectLogin>
        }
      />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/recover-password/:token/:email" element={<ChangePassword />} />

      {renderRoutes(adminRoutes, 'admin')}
      {renderRoutes(companyRoutes, 'company')}
      {renderRoutes(managerRoutes, 'manager')}
      {renderRoutes(attendantRoutes, 'attendant')}
    </Routes>
  )
}

const RedirectLogin: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { authData } = useAuth()
  let location = useLocation()
  if (!!authData?.token && !!authData?.role && location.pathname === '/login') {
    return <Navigate to={ROLE[authData.role]} replace />
  } else {
    return children
  }
}

export default RoutesFunction
